var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour-compass-wrapper"},[_c('eg-button',{class:[
      'tour-compass-button',
      { 'tour-compass-button--active': _vm.isActive },
    ],attrs:{"type":"ordinary","icon":"compass","icon-size":"medium","disabled":_vm.isRunning},on:{"click":_vm.onClick}}),_c('div',{staticClass:"tour-compass-hint"},[_vm._v(" "+_vm._s(_vm.$t("common.guidedTourHint"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }